import React from 'react'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import { LessonEl } from '../elements/lesson'
import { withRouter } from 'react-router-dom'
import { AssignmentOutlined } from '@material-ui/icons'

const Lesson = ({
  id,
  chapterId,
  title,
  match: {
    params: { livDemyID, courseURL },
  },
  active,
  disabled,
  type = 'VIDEO',
}) => {
  return (
    <LessonEl
      to={`/${livDemyID}/course/${courseURL}/chapter/${chapterId}/lesson/${id}`}
      active={active}
      disabled={disabled}
    >
      {type === 'VIDEO' ? (
        <PlayCircleOutlineIcon />
      ) : type === 'ASSIGNMENT' ? (
        <AssignmentOutlined />
      ) : null}
      <p>{title}</p>
    </LessonEl>
  )
}

export default withRouter(Lesson)
